import React from 'react';
import { type QnAStateType, selectors, StatefulQuestions } from '@uber/react-qna-lib';
import type { AnswerT } from '../types/types';
const SHOW_ANSWER_AS_SELECT_LIMIT = 10;
type PropsT = {
  isQuestionnaireComposable?: boolean;
  questionnaire: QnAStateType;
  onChange: (isAnswerValid?: boolean, answers?: AnswerT) => void;
  showValidationErrors?: boolean;
  enableAutoFocusForRTE?: boolean;
  styleOverrides?: {
    questionTitleStyles?: Record<string, string | number>;
    answerTextStyles?: Record<string, string | number>;
  };
};
function Questionnaire({
  questionnaire,
  onChange,
  showValidationErrors,
  isQuestionnaireComposable = true,
  enableAutoFocusForRTE,
  styleOverrides
}: PropsT) {
  const handleUpdateAnswers = (updatedAnswers: AnswerT) => {
    const transformedAnswer = Object.keys(updatedAnswers).reduce((transformedAnswers, questionId) => {
      transformedAnswers[questionId] = {
        ...updatedAnswers[questionId],
        tags: questionnaire.questions[questionId]?.tags || []
      };
      return transformedAnswers;
    }, {});
    const hasErrors = selectors.hasValidationErrors({
      ...questionnaire,
      answers: updatedAnswers
    });
    onChange(!hasErrors, transformedAnswer);
  };
  return <StatefulQuestions state={questionnaire} updateAnswers={handleUpdateAnswers} isComposeMode={isQuestionnaireComposable} enableAutoFocusForRTE={enableAutoFocusForRTE} showAnswerAsSelectLimit={SHOW_ANSWER_AS_SELECT_LIMIT} {...styleOverrides ? {
    styleOverrides
  } : {}} {...showValidationErrors ? {
    showValidationErrors: true
  } : {}} />;
}
export default Questionnaire;